import React, { useState } from "react";
import { containerStyle } from "../../styles/styles";
import { TableStyles } from "../../styles/table";
import LocalBarIcon from "@material-ui/icons/LocalBar";
import ActiveProviders from "../../uis/settings/providers";
import { useHistory } from "react-router-dom";
import ProviderModal from "../../uis/modals/addProvider/providerModal";

const ServiceProvider = () => {
  const classes = containerStyle();
  const tabClasses = TableStyles();
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => {
    setShowModal(false);
  };
  return (
    <>
      <ProviderModal
        title="Add Service Provider"
        open={showModal}
        close={handleClose}
        btnText="Service Provider Hospital"
      />
      <div
        style={{
          background: "#FFFFFF",
          padding: "1rem 1.5rem",
          display: "flex",
          alignItems: "center",
          borderBottom: "2px solid #E5E5E5",
          cursor: "pointer",
        }}
      >
        <img
          src="/assets/ion_arrow-back-circle.png"
          alt=""
          style={{ marginRight: "0.5rem" }}
          onClick={() => history.goBack()}
        />
        <p style={{ fontWeight: "700" }}>Back</p>
      </div>
      <div className={tabClasses.filterContainer}>
        <p>
          <LocalBarIcon /> Filter by:
        </p>
        <button
          className={tabClasses.addBtnlg}
          onClick={() => setShowModal(true)}
        >
          Add Service Provider
        </button>
      </div>
      <div className={classes.main}>
        <div className={tabClasses.tableRoot}>
          <div className={tabClasses.tabPanelContainer}>
            <ActiveProviders />
          </div>
        </div>
      </div>
    </>
  );
};

export default ServiceProvider;
